<template>
  <section>
    <div class="container">
      <div class="box">
        <div class="columns is-vcentered mb-2">
          <div class="column">
            <h3 class="is-size-3 has-text-weight-bold">Gestión de Roles FING</h3>
            <p class="has-text-grey is-size-6">Asignación y edición de roles gestionables por Secretaría Académica FING</p>
          </div>
          <div class="column is-narrow">
            <b-button @click.prevent="addModal" type="is-primary" icon-left="plus">Asignar Rol</b-button>
          </div>
        </div>

        <!-- Leyenda de roles -->
        <div class="tags mb-3">
          <span v-for="tag in roleTags" :key="tag.label" :class="['tag', tag.color, 'is-light']">{{ tag.label }}</span>
        </div>

        <b-tabs v-model="activeTab" type="is-boxed">

          <!-- TAB 1: Roles asignados en el sistema -->
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="users-cog" size="is-small"></b-icon>
              <span>Roles en sistema</span>
            </template>

            <b-table
                :data="people"
                :paginated="true"
                per-page="15"
                striped
                hoverable
                sticky-header
                height="600"
                :narrowed="true"
                :current-page.sync="currentPage"
                :pagination-simple="false"
                pagination-position="both"
                default-sort-direction="asc"
                sort-icon="arrow-up"
                sort-icon-size="is-small"
                aria-next-label="Siguiente"
                aria-previous-label="Anterior"
                aria-page-label="Página"
                aria-current-label="Página actual">

              <b-table-column field="run_completo" label="Rut" searchable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.run_completo !== "0" ? props.row.run_completo : "" }}
                </template>
              </b-table-column>

              <b-table-column field="complete_name" label="Nombre" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.complete_name }}
                </template>
              </b-table-column>

              <b-table-column field="person.corporate_mail" label="Correo corporativo" searchable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.person ? props.row.person.corporate_mail : "" }}
                </template>
              </b-table-column>

              <b-table-column field="internal_position.name" label="Rol" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  <span :class="['tag', roleColor(props.row.internal_position ? props.row.internal_position.name : ''), 'is-light']">
                    {{ props.row.internal_position ? props.row.internal_position.name : "" }}
                  </span>
                </template>
              </b-table-column>

              <b-table-column field="unit.name" label="Unidad" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.unit ? props.row.unit.name : "" }}
                </template>
              </b-table-column>

              <b-table-column field="start_date" label="Desde" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.start_date }}
                </template>
              </b-table-column>

              <b-table-column field="end_date" label="Hasta" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  <span :class="isExpired(props.row.end_date) ? 'has-text-danger' : ''">
                    {{ props.row.end_date || "Sin fecha término" }}
                  </span>
                </template>
              </b-table-column>

              <b-table-column label="Estado" v-slot="props">
                <span :class="['tag', isActive(props.row) ? 'is-success' : 'is-warning', 'is-light']">
                  {{ isActive(props.row) ? "Activo" : "Inactivo" }}
                </span>
              </b-table-column>

              <b-table-column label="Acciones" width="100px" v-slot="props">
                <b-tooltip
                    label="Ver información completa del rol."
                    position="is-left"
                    :active="true">
                  <b-button
                      pack="fas"
                      icon-left="eye"
                      type="is-primary"
                      @click="showModal(props.row)" />
                </b-tooltip>
                <b-tooltip
                    label="Editar información del rol."
                    position="is-left"
                    :active="true">
                  <b-button
                      pack="fas"
                      icon-left="edit"
                      type="is-info is-light is-outlined"
                      @click="editModal(props.row)" />
                </b-tooltip>
              </b-table-column>
            </b-table>
          </b-tab-item>

          <!-- TAB 2: Académicos con nombramiento sin acceso al sistema -->
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="user-clock" size="is-small"></b-icon>
              <span>Académicos sin acceso</span>
              <b-tag v-if="pendingAcademics.length > 0" type="is-warning" rounded class="ml-2">{{ pendingAcademics.length }}</b-tag>
            </template>

            <div class="notification is-info is-light mb-3">
              <b-icon pack="fas" icon="info-circle" size="is-small" />
              Estas personas tienen un <strong>nombramiento activo con cargo ACADÉMICO</strong> pero aún no tienen el
              <strong>rol</strong> asignado en el sistema. Usa <strong>Asignar rol</strong> para asignar el rol ACADÉMICO
              al nombramiento existente y crear su cuenta de acceso automáticamente si no la tiene.
            </div>

            <b-table
                :data="pendingAcademics"
                :paginated="true"
                per-page="15"
                striped
                hoverable
                sticky-header
                height="600"
                :narrowed="true"
                :current-page.sync="currentPagePending"
                :pagination-simple="false"
                pagination-position="both"
                default-sort-direction="asc"
                sort-icon="arrow-up"
                sort-icon-size="is-small"
                aria-next-label="Siguiente"
                aria-previous-label="Anterior"
                aria-page-label="Página"
                aria-current-label="Página actual">

              <template slot="empty">
                <div class="has-text-centered py-4 has-text-grey">
                  <b-icon pack="fas" icon="check-circle" size="is-large" type="is-success" />
                  <p class="mt-2">Todos los académicos con nombramiento ya tienen acceso al sistema.</p>
                </div>
              </template>

              <b-table-column field="run_completo" label="Rut" searchable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.run_completo !== "0" ? props.row.run_completo : "" }}
                </template>
              </b-table-column>

              <b-table-column field="complete_name" label="Nombre" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.complete_name }}
                </template>
              </b-table-column>

              <b-table-column field="person.corporate_mail" label="Correo corporativo" searchable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.person ? props.row.person.corporate_mail : "" }}
                </template>
              </b-table-column>

              <b-table-column field="unit.name" label="Unidad del nombramiento" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.unit ? props.row.unit.name : "" }}
                </template>
              </b-table-column>

              <b-table-column field="start_date" label="Nombramiento desde" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  {{ props.row.start_date }}
                </template>
              </b-table-column>

              <b-table-column field="end_date" label="Hasta" searchable sortable>
                <template slot="searchable" slot-scope="props">
                  <b-input v-model="props.filters[props.column.field]" placeholder="Buscar" icon="search" size="is-small" />
                </template>
                <template slot-scope="props">
                  <span :class="isExpired(props.row.end_date) ? 'has-text-danger' : ''">
                    {{ props.row.end_date || "Sin fecha término" }}
                  </span>
                </template>
              </b-table-column>

              <b-table-column label="Acciones" width="120px" v-slot="props">
                <b-tooltip
                    label="Asignar rol ACADÉMICO al nombramiento y crear acceso al sistema."
                    position="is-left"
                    :active="true">
                  <b-button
                      pack="fas"
                      icon-left="user-plus"
                      type="is-warning is-light is-outlined"
                      size="is-small"
                      @click="createAccessModal(props.row)">
                    Asignar rol
                  </b-button>
                </b-tooltip>
              </b-table-column>
            </b-table>
          </b-tab-item>

        </b-tabs>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
      </div>
    </div>

    <!-- Modal Ver -->
    <b-modal v-model="show" has-modal-card trap-focus :destroy-on-hide="true" width="1024"
             aria-role="dialog" aria-modal>
      <template #default="props">
        <modal-show-annex-roles
            :id="selectedId"
            :complete_name="complete_name"
            :complete_rut="complete_rut"
            :corporate_mail="corporate_mail"
            :person="prop_person"
            :queryType="queryType"
            query-type="show"
            modal-header="Detalle Rol"
            @close="props.close" />
      </template>
    </b-modal>

    <!-- Modal Agregar / Editar -->
    <b-modal v-model="showAddEdit" has-modal-card trap-focus :destroy-on-hide="true" width="1024"
             aria-role="dialog" aria-modal :can-cancel="canCancel">
      <template #default="props">
        <modal-add-roles-fing
            :id="selectedId"
            :queryType="queryType"
            :personId="personId"
            @close="props.close" />
      </template>
    </b-modal>
  </section>
</template>

<script>
import axios from "axios";
import ModalShowAnnexRoles from './modal_show_annex_roles.vue';
import ModalAddRolesFing from './modal_add_roles_fing.vue';

export default {
  name: "roles_list_fing",
  components: {
    ModalShowAnnexRoles,
    ModalAddRolesFing
  },
  data() {
    return {
      people: [],
      pendingAcademics: [],
      activeTab: 0,
      currentPage: 1,
      currentPagePending: 1,
      isLoading: false,
      canCancel: ['escape'],
      show: false,
      showAddEdit: false,
      complete_rut: "",
      complete_name: "",
      corporate_mail: "",
      personId: "",
      queryType: "",
      selectedId: "",
      prop_person: "",
      roleTags: [
        { label: "DECANO / SECRETARÍA ACAD.", color: "is-danger" },
        { label: "JEFE ADMINISTRATIVO", color: "is-warning" },
        { label: "DIRECTOR DEPTO.", color: "is-info" },
        { label: "ANALISTA", color: "is-success" },
        { label: "ACADÉMICO", color: "is-primary" },
      ]
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.isLoading = true;
      axios.get("/people/roles_list_fing.json")
          .then(res => {
            this.people = res.data.annex_roles.map(person => ({
              ...person,
              start_date: this.formatDate(person.start_date),
              end_date: this.formatDate(person.end_date)
            }));
            this.pendingAcademics = res.data.pending_academics.map(person => ({
              ...person,
              start_date: this.formatDate(person.start_date),
              end_date: this.formatDate(person.end_date)
            }));
            this.isLoading = false;
          })
          .catch(error => {
            console.log(error);
            this.isLoading = false;
          });
    },
    showModal(row) {
      this.selectedId = row.id;
      this.complete_rut = row.run ? row.run.rut.toString() + "-" + row.run.dv : "";
      this.corporate_mail = row.person ? row.person.corporate_mail : "";
      this.complete_name = row.complete_name;
      this.prop_person = row.person;
      this.queryType = "show";
      this.show = true;
    },
    editModal(row) {
      this.selectedId = row.id;
      this.personId = row.person ? row.person.id : null;
      this.queryType = "update";
      this.showAddEdit = true;
    },
    addModal() {
      this.selectedId = null;
      this.queryType = "create";
      this.showAddEdit = true;
    },
    createAccessModal(row) {
      // Edita el NOMBRAMIENTO existente para asignarle el rol ACADÉMICO (igual que appointments_list),
      // no crea un cargo anexo nuevo.
      this.selectedId = row.id;
      this.personId = row.person ? row.person.id : null;
      this.queryType = "update";
      this.showAddEdit = true;
    },
    formatDate(date) {
      if (date) {
        const parts = date.split("-");
        return parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : date;
      }
      return "";
    },
    isExpired(endDate) {
      if (!endDate) return false;
      const parts = endDate.split("-");
      if (parts.length !== 3) return false;
      const d = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      return d < new Date();
    },
    isActive(row) {
      const today = new Date();
      const start = row.start_date ? new Date(row.start_date.split("-").reverse().join("-")) : null;
      const end = row.end_date ? new Date(row.end_date.split("-").reverse().join("-")) : null;
      if (start && start > today) return false;
      if (end && end < today) return false;
      return true;
    },
    roleColor(name) {
      if (!name) return "is-light";
      if (name.includes("DECANO") || name.includes("SECRETARIA ACADEMICA")) return "is-danger";
      if (name.includes("JEFE ADMINISTRATIVO")) return "is-warning";
      if (name.startsWith("DIR DEPTO")) return "is-info";
      if (name.includes("ANALISTA")) return "is-success";
      if (name === "ACADEMICO") return "is-primary";
      return "is-light";
    }
  },
  watch: {
    showAddEdit(val) {
      if (!val) this.initialize();
    }
  }
};
</script>
